var matchHeight = function () {
	function init() {
		eventListeners();
		matchHeight();
	}

	function eventListeners() {
		$(window).on('resize', function () {
			matchHeight();
		});
	}

	function matchHeight() {
		var groupName = $('.prowrap .iconimg');
		var groupHeights = [];

		groupName.css('min-height', 'auto');

		groupName.each(function () {
			if ($(window).width() > 767) {
				groupHeights.push($(this).outerHeight());
			}

		});

		var maxHeight = Math.max.apply(null, groupHeights);
		groupName.css('min-height', maxHeight);
	};

	return {
		init: init
	};
}();

function setLineStyle(tab) {
	if($('.lines-add').length > 0) {
		let line = document.querySelector('.lines-add');
		var lineleft = `${tab.offsetLeft}px`
		line.style.left = lineleft;
		line.style.width = tab.clientWidth + "px";
	}
}

/* bind events on load */
window.onload = function () {
	$('.nav > .nav-item').each(function (index, tab) {
		if (index == 0) setLineStyle(tab);
		$(this).click(function () {
			setLineStyle(tab)
		});
	});

  $('.missiontablinks a#nav-tab2').trigger('click');
};

$(window).resize(function () {
	$('.nav > .nav-item').each(function (index, tab) {
		if ($(this).find('.nav-link').hasClass('active')) {
			setLineStyle(tab);
		}
	})
});

$('.nav-tabs-dropdown')
	.on("click", "li", function (event) {
		$(this).addClass('active');
		$(this).siblings().removeClass('active');
	});

$('.nav-tabs-dropdown')
	.on("click", "li:not('.active') a", function (event) {
		$(this).closest('ul').removeClass("open");
	})
	.on("click", "li.active a", function (event) {
		$(this).closest('ul').toggleClass("open");
	});


$(window).on('load', function () {
	if ($('#bannervideo').hasClass('lazyloaded')) {
		setTimeout(function () {
			$('.sectionbanner').addClass('videoloaded');
		}, 500);
		$(".loader").delay(1600).fadeOut("slow");
		// $("#overlayer").delay(1600).fadeOut("slow");
	}
});

$(window).on('scroll', function () {
	if ($('#bannervideo').hasClass('lazyloaded')) {
		$(".loader").fadeOut();
		// $("#overlayer").fadeOut();
	}
});

function openCart() {
	jQuery.getJSON('/cart.js', function(data) {
		refreshCart(data);
		jQuery('body').addClass('body-cart-open');
		jQuery('.slideCart').addClass('cart-open');
	});
}

function refreshCart(cart) {
  var $cart = $('.cartItemMain .rowWrapper');
  var cart_items_html = "";
  var cart_subtotal = $('.finalPrice p');
  cart_subtotal.text(Shopify.formatMoney(cart.total_price, theme.moneyFormat));
  if (cart.total_price < 30000) {
    var percentage = (cart.total_price / 30000) * 100;
    var substraction = (30000 - cart.total_price) / 100;
    $(".js-shipping-line-text").html(`You are <span class="textPirce">$${substraction}</span> away from getting free shipping.`);
    $(".js-bar-active").attr('style', `width:${percentage}%`);
  } else {
    $(".js-shipping-line-text").html("You qualify for free shipping.");
    $(".js-bar-active").attr('style', "width:100%");
  }
  $("[data-prodsuggest]").fadeIn(10);
  if (cart.item_count == 0) {
    $cart.html('<div class="row mb20"><div class="col-12 cartEmptyy">Your Cart is empty.</div></div>');
  } else {
    $.each(cart.items, function(index, item) {
      $(`[data-prodsuggest='${item.product_id}']`).fadeOut(10);
      index = index + 1;
      cart_items_html += '<div class="row mb20">';
      if (item.image) {
        cart_items_html += '<div class="col-4">' + '<div class="cartImg">' + '<img src="' + item.image.replace(/(\.[^.]*)$/, "_medium$1").replace('http:', '') + '" class="img-fluid" alt="' + item.title + '">' + '</div>' + '</div>';
      }
      cart_items_html += '<div class="col-8">' + '<div class="cartItemContent" data-line="' + parseInt(index) + '" data-id="' + item.id + '">';
      cart_items_html += '<div class="cartItemTitle">' + '<h4>' + item.product_title + '</h4>' + '</div>';
			if(typeof item.variant_title !== 'undefined' && item.variant_title) {
      	cart_items_html += '<div class="cartItemTitle"><h2>' + item.variant_title + '</h2></div>';
			}
			if(typeof item.selling_plan_allocation !== 'undefined') {
				cart_items_html += '<div class="cartItemTitle subscriptionTitle"><h2>' + item.selling_plan_allocation.selling_plan.name + '</h2></div>';
			}
      cart_items_html += '<div class="cartItemContentBtm">';
      cart_items_html += '<div class="cartQuantity"> ' + '<div class="quantityBox">' + '<div class="quantityRange">';
      cart_items_html += '<input type="button" value="-" class="qtyminus" field="quantity">' + '<input type="text" name="quantity" value="' + item.quantity + '" class="qty" >' + '<input type="button" value="+" class="qtyplus" field="quantity">';
      cart_items_html += '</div>' + '</div><div class="remove_item" data-line-id="' + parseInt(index) + '"><a href="#">Remove</a></div> ' + '</div>';
      cart_items_html += "<div class='cartItemPrice'>" + "<p class='price'>" + Shopify.formatMoney(item.price * item.quantity, theme.moneyFormat) + "</p>" + "</div>";
      cart_items_html += '</div>';
      cart_items_html += '</div></div>';
      cart_items_html += '</div>';
    });
    $cart.html(cart_items_html);
  }
  $(".slideCartLoader").fadeOut(100);
}

$(document).ready(function () {
	if($('.subscriptiontablinks #myTab li').length > 1) {
		$('.subscriptiontablinks').show();
	}

	$('.lpg-header-cart').on('click', function(e) {
		e.preventDefault();
		openCart();
	});

	$(document).on('click', '.remove_item', function(e) {
    $(".slideCartLoader").fadeIn(5);
    e.preventDefault();

    var lineID = $(this).data('line-id');
    $.ajax({
        url: '/cart/change.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: { quantity: 0, line: lineID },
        success: function(data) {
					refreshCart(data);
        }
    });
	});

	jQuery('.slideCart .close').on('click', function() {
    jQuery('body').removeClass('body-cart-open');
    jQuery('.slideCart').removeClass('cart-open');
	});

	$(document).on('click', '.qtyplus', function(e) {
		$(".slideCartLoader").fadeIn(5);
		var cur_em = e.target;
		var parent_em = $(cur_em).parents('[data-id]').eq(0);
		var cur_qty = $(parent_em).find('[name="quantity"]').val();
		var variant_id = $(cur_em).parents('[data-id]').eq(0).attr('data-id');
		var new_qty = parseInt(cur_qty) + 1;
		$(parent_em).find('[name="quantity"]').val(new_qty);
		$(parent_em).find('[name="quantity"]').val(new_qty).trigger('change');
	});

	$(document).on('click', '.qtyminus', function(e) {
		$(".slideCartLoader").fadeIn(5);
		var cur_em = e.target;
		var parent_em = $(cur_em).parents('[data-id]').eq(0);
		var cur_qty = $(parent_em).find('[name="quantity"]').val();
		var variant_id = $(cur_em).parents('[data-id]').eq(0).attr('data-id');
		var new_qty = parseInt(cur_qty) - 1;
		if (parseInt(cur_qty) <= 0) {
				var new_qty = 0;
		}
		$(parent_em).find('[name="quantity"]').val(new_qty).trigger('change');
	});

	$(document).on('change', '.cartQuantity [name="quantity"]', function(e) {
		$(".slideCartLoader").fadeIn(5);
		var cur_em = e.target;
		var parent_em = $(cur_em).parents('[data-id]').eq(0);
		var cur_qty = $(cur_em).val();
		var variant_id = $(cur_em).parents('[data-id]').eq(0).attr('data-id');
		$.ajax({
			url: "/cart/change.js",
			data: { id: variant_id, quantity: cur_qty },
			dataType: "JSON",
			method: "POST",
			success: function(data) {
				$.get('/cart.json', function(cart) {
					refreshCart(cart);
				});
			}
		})
	});

	$('.lpg-normal-form').on('submit', function(e) {
		let form_data = $(this).serialize();
		console.log('form_data',form_data);
		e.preventDefault();
		$.ajax({
			url: "/cart/add.js",
			data: form_data,
			method: "POST",
			dataType: "JSON",
			success: function (data) {
				$.get('/cart.json', function (cart) {
					refreshCart(cart);
					openCart();
				});
			},
			error: function (data) {
				alert(data.responseJSON.description);
			}
		});        
	});

	$('.mobile-trigger').click(function () {
		$(this).toggleClass('active-re');
		$('#navbarsId').slideToggle();
	});

	document.addEventListener('lazybeforeunveil', function (e) {
		var bg = e.target.getAttribute('data-bg');
		if (bg) {
			e.target.style.backgroundImage = 'url(' + bg + ')';
		}
	});

	/* initialize fancybox */
	$(".fancybox").fancybox();

	$('.reviewsllides').slick({
		dots: true,
		infinite: true,
		slidesToShow: 3,
		slidesToScroll: 3,
		arrows: true,
		prevArrow: "<i class='material-icons left'>keyboard_arrow_left</i>",
		nextArrow: "<i class='material-icons right'>keyboard_arrow_right</i>",
		responsive: [{
			breakpoint: 992,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 2,
				infinite: true,
				dots: true
			}
		},
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}
		]
	});

	$('.tabslide-shop').slick({
		dots: false,
		infinite: false,
		slidesToShow: 3.5,
		slidesToScroll: 1,
		arrows: false,
		prevArrow: "<i class='material-icons left'>keyboard_arrow_left</i>",
		nextArrow: "<i class='material-icons right'>keyboard_arrow_right</i>",
		responsive: [
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 3.5,
				slidesToScroll: 1,
			}
		},{
			breakpoint: 376,
			settings: {
				slidesToShow: 3.5,
			}
		}
		]
	});

	$('.fetslid').slick({
		dots: false,
		infinite: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: true,
		prevArrow: "<i class='material-icons left'>keyboard_arrow_left</i>",
		nextArrow: "<i class='material-icons right'>keyboard_arrow_right</i>",
		responsive: [{
			breakpoint: 1200,
			settings: {
				slidesToShow: 3,
			}
		},
		{
			breakpoint: 992,
			settings: {
				slidesToShow: 2,
			}
		},
		{
			breakpoint: 576,
			settings: {
				slidesToShow: 2,
			}
		}
		]
	});

	$('.fooslidewrap').slick({
		dots: false,
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		autoplay: true,
		autoplaySpeed: 5000,
		fade: true,
		speed: 500,
		touchThreshold: 5,
		draggable: true
    })
	$('.fooslidewrap').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
		//alert(currentSlide)
		$(slick.$slides[nextSlide]).removeClass('animate-out');
		$(slick.$slides[currentSlide]).addClass('animate-out');
	})
	$('.fooslidewrap').on('afterChange', function (event, slick, currentSlide, nextSlide) {
		$(slick.$slides[nextSlide]).addClass('animate-out');
		$(slick.$slides[currentSlide]).removeClass('animate-out');
	});

	$slick_slider = $('.logoslider');
	settings_slider = {
		slidesToShow: 4,
		slidesToScroll: 1,
		dots: false,
		arrows: false,
		prevArrow: "<i class='fas fa-chevron-left left'></i>",
		nextArrow: "<i class='fas fa-chevron-right right'></i>",
	}
	slick_on_mobile($slick_slider, settings_slider);

	// slick on mobile
	function slick_on_mobile(slider, settings) {
		$(window).on('load resize', function () {
			if ($(window).width() > 575) {
				if (slider.hasClass('slick-initialized')) {
					slider.slick('unslick');
				}
				return
			}
			if (!slider.hasClass('slick-initialized')) {
				return slider.slick(settings);
			}
		});
	};

	$('.gocheck').on('click', function (e) {
		var target = this.hash;
		if(target) {
			e.preventDefault();
			var $target = $(target);
			$('html, body').stop().animate({
				'scrollTop': $target.offset().top
			}, 900, 'swing', function () {
				// window.location.hash = target;
			});
		}
	});

	var numSlick = 0;
	$('.proslider').each(function () {
		numSlick++;
		$(this).addClass('large-' + numSlick).slick({
			lazyLoad: 'ondemand',
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			fade: false,
			centerMode: true,
			asNavFor: '.prosmall.thumbnail-' + numSlick,
		});
	});

	numSlick = 0;
	$('.prosmall').each(function () {
		numSlick++;
		$(this).addClass('thumbnail-' + numSlick).slick({
			slidesToShow: 4,
			slidesToScroll: 1,
			asNavFor: '.proslider.large-' + numSlick,
			dots: false,
			centerMode: false,
			focusOnSelect: true,
			vertical: true,
			verticalSwiping: true,
			prevArrow: "false",
			nextArrow: "<i class='fas fa-chevron-down right'></i>",
			responsive: [{
				breakpoint: 576,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 1,
					verticalSwiping: false,
					horizontal: true,
					vertical: false,
					prevArrow: "<i class='material-icons left'>keyboard_arrow_left</i>",
					nextArrow: "<i class='material-icons right'>keyboard_arrow_right</i>",
				},
			},],
		})
			.on('setPosition', function (event, slick) {
				resizeheight();
			});
	});

	$('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
		if ($(window).width() < 575) {
			setTimeout(function () {
				$('.logoslider').slick('setPosition');
			}, 50);
		}
		setTimeout(function () {
			$('.proslider').slick('setPosition');
			$('[class*="thumbnail-"]').slick('refresh');
		}, 500);
	})


	$('.carthead').click(function (e) {
		$('.checkoutcart').addClass('cartopen');
		$('body').addClass('overlayin');
		e.stopPropagation();
	});

	$('.closebtn').click(function (e) {
		$('.checkoutcart').removeClass('cartopen');
		$('body').removeClass('overlayin');
		e.stopPropagation();
	});

	$('body').click(function () {
		$('.checkoutcart').removeClass('cartopen');
		$(this).removeClass('overlayin');
	});


	String.prototype.getDecimals || (String.prototype.getDecimals = function () {
		var a = this,
			b = ("" + a).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
		return b ? Math.max(0, (b[1] ? b[1].length : 0) - (b[2] ? +b[2] : 0)) : 0
	});
	$(".plus, .minus").click(function () {
		var a = jQuery(this).closest(".quantity").find(".qty"),
			b = parseFloat(a.val()),
			c = parseFloat(a.attr("max")),
			d = parseFloat(a.attr("min")),
			e = a.attr("step");
		b && "" !== b && "NaN" !== b || (b = 0), "" !== c && "NaN" !== c || (c = ""), "" !== d && "NaN" !== d || (d = 0), "any" !== e && "" !== e && void 0 !== e && "NaN" !== parseFloat(e) || (e = 1), jQuery(this).is(".plus") ? c && b >= c ? a.val(c) : a.val((b + parseFloat(e)).toFixed(e.getDecimals())) : d && b <= d ? a.val(d) : b > 0 && a.val((b - parseFloat(e)).toFixed(e.getDecimals())), a.trigger("change")
		a.attr('value', a.val());
	});

	$('.checkoutcart').click(function (e) {
		e.stopPropagation();
	})

	$('.prottl').matchHeight({
		byRow: true
	});

	$('.motodesc').matchHeight({
		byRow: true
	});

	$('.clubwrap .clubimg  + p').matchHeight({
		byRow: true
	});

	var resizeheight = function () {
		$('.pronigimg .slick-slide').each(function () {
			var widthslide = $(this).width();
			$(this).css('height', widthslide);
		});
	}
	$('.clickelement').click(function (e) {
		$('.dropmenu').not($(this).next()).slideUp();
		$(this).next().slideDown();
		e.stopPropagation();
	});
	$('.onlickProductChange .dropmenu li').click(function (e) {
		e.stopPropagation();
		$(this).addClass('selected');
		var dropvalue = $(this).data('value');
		$(this).parent().prev().find('.selectred-value .colorname').text(dropvalue);
		$('.dropmenu').slideUp();
    	var dataHref = $(this).attr("data-href");
    	window.location.href = dataHref;
    });
	$('.shopify-product-form .dropmenu li').click(function (e) {
		e.stopPropagation();
		$(this).addClass('selected');
		var dropvalue = $(this).data('value');
		if ($(this).parent().hasClass('colorchart')) {
			var dropcolor = $(this).data('color');
			$(this).parent().prev().find('.selectred-value .color').css('background-color', dropcolor);
			$(this).parent().prev().find('.selectred-value .colorname').text(dropvalue);
		} else {
			$(this).parent().prev().find('.selectred-value').text(dropvalue).charAt(0).toUpperCase();
		}
		$('.dropmenu').slideUp();
			$(this).parents('form').find('.product-single__variants option').removeAttr('selected');
			$(this).parents('form').find('.product-single__variants option').prop('selected',false);
			$(this).parents('form').find('.product-single__variants option').each(function(){
				var s_this = $(this);
				var val =  s_this.attr('data-value');

				if(val == dropvalue){
					var var_id = s_this.val();
					s_this.prop('selected',true);
					s_this.attr('selected','selected');

					if(window.location.href.indexOf('variant=') > -1){
						var newurl = window.location.href.split('variant=')[0] + 'variant=' + s_this.val();
					}
					else{
						if(window.location.href.indexOf('?') > -1){
							var newurl = window.location.href + '&variant=' + s_this.val();
						}
						else{
							var newurl = window.location.href + '?variant=' + s_this.val();
						}
					}
					window.location.href = newurl;
				}
			});
	});


  $(document).on('click', '.subscription_btn', function(e){
    e.preventDefault();

    var current_element = $(this);
    let subscription_id = current_element.parents('form').find('.product-single__variants').val();
		let selling_plan = current_element.parents('form').find('input[name="selling_plan"]').val();
		let quantity = current_element.parents('form').find('input[name="quantity"]').val();

		if(typeof quantity === "undefined" || quantity == 0) {
			quantity = 1;
		}

    var data = {
      id : subscription_id,
      quantity : quantity,
	  	selling_plan: selling_plan
    }

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: data,
      success: function(success_data) {
        $.get('/cart.json', function (cart) {
					refreshCart(cart);
					openCart();
				});
      },
      error: function(data) {
        alert(data.responseJSON.description);
      }
    });
  });

  $(document).on('change', 'input[name="subscription"]', function(){
    var $this = $(this);
    if($this.prop == "true"){
      $this.parents('form').find('.btnpament').addClass('subscription_btn');
    }
    else{
      $this.parents('form').find('.btnpament').removeClass('subscription_btn');
    }
  });

	$('body').click(function () {
		$('.dropmenu').slideUp();
	});

	matchHeight.init();

	AOS.init({
		once: true
	});

	var a = 0;
	$(window).scroll(function () {
		if($('.numbergame').length > 0) {
			var oTop = $('.numbergame').offset().top - window.innerHeight;
			if (a == 0 && $(window).scrollTop() > oTop) {
				$('.num').each(function () {
					var $this = $(this),
						countTo = $this.attr('data-num');
					$({
						countNum: $this.text()
					}).animate({
						countNum: countTo
					},
					{
						duration: 2000,
						easing: 'swing',
						step: function () {
							$this.text(Math.floor(this.countNum));
						},
						complete: function () {
							$this.text(this.countNum);
							//alert('finished');
						}

					});
				});
				a = 1;
			}
		}
	});

	$('.filtertabwrap').click(function () {
		var tagid = $(this).data('href');
		$('#' + tagid).addClass('active-filter show');
		$('#' + tagid).siblings().removeClass('active-filter show');
	});

	$('.filterselect').on('change', function (e) {
		var filterid = this.value;
		$('#' + filterid).addClass('active-filter show');
		$('#' + filterid).siblings().removeClass('active-filter show');
	});

  $(document).on('click', '.filtertext,.filterimg', function(e){
    e.preventDefault();

    var href = $(this).parents('.filtertabwrap').attr('data-href');
    var newurl = window.location.protocol + '//' + window.location.host + '/collections/' +  href;
    window.location.href = newurl;

  });

  $('.subscriptiontablinks .nav-link').on('click', function(e){
    e.preventDefault();

    var newurl = $(this).attr('data-href');
    if($(this).hasClass("active"))
    {
    }
    else
    {
    	window.location.href = newurl;
    }
  });

  $(document).on('change', '.filterselect', function(){
    var val = $(this).val();

    if(window.location.href.indexOf('sort_by') > -1){
      window.location.href = window.location.href.split('sort_by=')[0] + 'sort_by='+ val;
    }
    else{
      if(window.location.href.indexOf('?') > -1){
        window.location.href = window.location.href + '&sort_by='+ val;
      }
      else{
        window.location.href = window.location.href + '?sort_by='+ val;
      }
    }
  });

  /*
  if($('.pro_description').length > 0) {
	$('.pro_description').Cuttr({
		//options here
		truncate: 'sentences',
		length: 2,
		ending: '',
		readMore: true,
		readMoreText: 'Find out more..',
		readLessText: '',
	});
  }
  */
});

$(document).ready(function () {
	if($('.subscriptiontablinks #myTab').length > 0) {
		var active_tab = $('.subscriptiontablinks #myTab li.active > a.active').attr('id');
		if(active_tab == "nav-tab-1") {
			$('.whyjoin.whyjoin-1').fadeIn();
		}
		if(active_tab == "nav-tab-2") {
			$('.whyjoin.whyjoin-2').fadeIn();
		}
		if(active_tab == "nav-tab-3") {
			$('.whyjoin.whyjoin-3').fadeIn();
		}
	}
});
var headerPosition = 0;
var headerHeight = 0;
var total = 0;
$(document).ready(function () {
	if($(".poshead .headermain").hasClass("is_sticky_enabled"))
	{
		headerPosition = $(".poshead .headermain").offset().top;
		headerHeight = $(".poshead .headermain").outerHeight();
		total = parseInt(headerPosition) + parseInt(headerHeight);
		if(total > 0)
		{
			if(scroll > total)
			{
				if($(".poshead .headermain").hasClass("is_sticky"))
				{
				}
				else
				{
					$(".poshead .headermain").addClass("is_sticky");
				}
			}
			else
			{
				$(".poshead .headermain").removeClass("is_sticky");
			}
		}
	}
});
$(window).on("scroll", function () {
	if($(".poshead .headermain").hasClass("is_sticky_enabled"))
	{
		var scroll = $(window).scrollTop();
		if(total > 0)
		{
			if(scroll > total)
			{
				if($(".poshead .headermain").hasClass("is_sticky"))
				{
				}
				else
				{
					$(".poshead .headermain").addClass("is_sticky");
				}
			}
			else
			{
				$(".poshead .headermain").removeClass("is_sticky");
			}
		}
	}
});